import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RouteLoadingService {
  readonly visible = signal(false);
  readonly url = signal('/dashboard');
  private startedAt = Date.now();
  private navigationFinished = false;
  private generation = 0;
  private finishTimer?: ReturnType<typeof setTimeout>;
  private failsafeTimer?: ReturnType<typeof setTimeout>;
  // Piso antiparpadeo (no una espera artificial de segundos): mismo criterio
  // que utils/loading.ts para el resto del sistema.
  private readonly minimumDuration = 0;
  private readonly maximumDuration = 12000;

  showInitialLoad(url: string): void {
    this.beginNavigation(url);
    this.finishNavigation();
  }

  beginNavigation(url: string): void {
    if (this.finishTimer) clearTimeout(this.finishTimer);
    if (this.failsafeTimer) clearTimeout(this.failsafeTimer);
    this.url.set(url);
    this.startedAt = Date.now();
    this.navigationFinished = false;
    this.generation++;
    this.visible.set(true);
    const expectedGeneration = this.generation;
    this.failsafeTimer = setTimeout(() => {
      if (expectedGeneration === this.generation) this.visible.set(false);
    }, this.maximumDuration);
  }
  finishNavigation(): void { this.navigationFinished = true; this.tryFinish(); }
  private tryFinish(): void {
    if (!this.navigationFinished) return;
    const remaining = Math.max(0, this.minimumDuration - (Date.now() - this.startedAt));
    if (this.finishTimer) clearTimeout(this.finishTimer);
    const expectedGeneration = this.generation;
    this.finishTimer = setTimeout(() => {
      if (expectedGeneration !== this.generation || !this.navigationFinished) return;
      this.visible.set(false);
      if (this.failsafeTimer) clearTimeout(this.failsafeTimer);
    }, remaining);
  }
}
